const getTodayStartEnd = (): [Date, Date] => {
  const now = new Date();

  const start = now.setHours(0, 0, 0, 0);
  const end = now.setHours(23, 59, 59, 99);

  return [new Date(start), new Date(end)];
};

export default getTodayStartEnd;
